<template>
	<div class="review--submit" v-if="!submitted">
		<h2>Write a review</h2>
		<p>Enter your review</p>
		<ValidationObserver ref="observer" v-slot="{ invalid }" tag="form" @submit.prevent="saveReview">
			<div class="form-group input-extra">
				<ValidationProvider
					rules="required"
					v-slot="{ errors, failedRules }"
					class="input-name form-element"
				>
					<input type="text" class="form-control" id="name" placeholder="Your name" v-model="form.name" :class="{ 'input-error is-invalid': errors.length }">
					<label for="name" v-text="$__('checkout.form.billing_name')"></label>
					<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
				</ValidationProvider>
			</div>

			<div class="form-group input-extra">
				<ValidationProvider
					rules="required"
					v-slot="{ errors, failedRules }"
					class="input-name form-element"
				>
					<textarea class="form-control" id="review" placeholder="Your review" v-model="form.review" :class="{ 'input-error is-invalid': errors.length }"></textarea>
					<label for="review" v-text="$__('form.review.content')"></label>
					<div v-if="failedRules.required" class="invalid-feedback" v-text="$__('form.error.generic')"></div>
				</ValidationProvider>
			</div>

			<ValidationProvider
				rules="min_value:1"
				v-slot="{ errors }"
				class="input-name form-element"
			>
				<label for="rating" ></label>
				<star-rating
					class="mb-4"
					id="rating"
					v-model="form.rating"
					v-bind:rating="0"
					active-color="#E6007E"
					border-color="#E6007E"
					v-bind:border-width="2"
					v-bind:padding="1"
					inactive-color="#FFFFFF"
					v-bind:star-size="22"
					v-bind:rounded-corners="true"
					:class="{ 'input-error is-invalid': errors.length }">
				</star-rating>
				<div v-if="errors.length" class="invalid-feedback">
					{{ errors[0] }}
				</div>
			</ValidationProvider>

			<button class="btn btn-primary" type="submit" :disabled="disabled" v-text="$__('form.review.send')"></button>
		</ValidationObserver>
	</div>
	<div v-else>
		<p v-text="$__('form.review.success')"></p>
	</div>
</template>

<script>
import StarRating from 'vue-star-rating';
import { ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import { required, is_not, min_value } from 'vee-validate/dist/rules';

extend('required', {
	...required,
	message: 'This field is required',
});

extend('min_value', {
	...min_value,
	message: 'Please rate the product.',
});

export default {
	name: "Review",
	props: {
		product: Number
	},
	data: function() {
		return {
			form: {
				id: this.product,
				rating: 0,
				lang: window.sharedData.locale
			},
			submitted: false,
			disabled: false
		}
	},
	components: {
		ValidationObserver,
		ValidationProvider,
		StarRating
	},
	methods: {
		async saveReview () {
			const isValid = await this.$refs.observer.validate();
			if (!isValid) {
				return false;
			}
			this.disabled = true;
			axios.post('/api/review', this.form)
				.then(response => {
					if (!response.error) {
						this.disabled = false;
						this.submitted = true;
					}
				})
				.catch(function (error) {
					// error
				});
			return false;
		}
	},
	mounted() {

	}
}
</script>
